
import { LevelConfig } from '@/models/LearnTypes';

// Define the level configurations
export const LEVEL_CONFIGS: LevelConfig[] = [
  {
    type: 'match',
    title: 'Level 1: Match Words',
    description: 'Word matching',
    xpReward: 5,
    state: 'not-started'
  },
  {
    type: 'flashcard',
    title: 'Level 2: Flash Cards',
    description: 'Learn the French words',
    xpReward: 10,
    state: 'not-started'
  },
  {
    type: 'reverse-flashcard',
    title: 'Level 3: Reverse Flash Cards',
    description: 'Test your memory with English words',
    xpReward: 20,
    state: 'not-started'
  },
  {
    type: 'spelling',
    title: 'Level 4: Spelling',
    description: 'Practice spelling the French words',
    xpReward: 30,
    state: 'not-started'
  }
];
